import { RequestPagination, SearchCriteriaItem } from "@/libs/vulnUtil";

export const API_PATH_VVT = "v1/vvt";
export const SYSTEM_ERROR = "System Error";

export const getPaginationParams = (pagination: RequestPagination) => {
  return ["offset=" + pagination.offset, "limit=" + pagination.limit];
};

export const getCriteriaParams = (
  criteria: SearchCriteriaItem,
  statusName: string,
) => {
  const params = [];
  if (criteria.freeWord != null && criteria.freeWord.length > 0) {
    params.push("keyword=" + criteria.freeWord);
  }

  const regex = /-/g;
  const termFrom = criteria.termFrom.replace(regex, "");
  if (termFrom.length == 6) {
    params.push("term_from=" + termFrom);
  }
  const termTo = criteria.termTo.replace(regex, "");
  if (termTo.length == 6) {
    params.push("term_to=" + termTo);
  }

  const status: string[] = [];
  const statusAll = !(
    criteria.attentional ||
    criteria.important ||
    criteria.critical
  );
  if (statusAll || criteria.attentional) {
    status.push("0");
  }
  if (statusAll || criteria.important) {
    status.push("1");
  }
  if (statusAll || criteria.critical) {
    status.push("2");
  }
  params.push(statusName + "=" + status.join(","));

  const tag: string[] = [];
  const tagAll = !(criteria.microsoft || criteria.redhat || criteria.apple);
  if (tagAll || criteria.microsoft) {
    tag.push("0");
  }
  if (tagAll || criteria.redhat) {
    tag.push("1");
  }
  if (tagAll || criteria.apple) {
    tag.push("2");
  }
  params.push("tag=" + tag.join(","));

  if (params.length == 0) {
    params.push("term_to=999912");
  }

  return params;
};
